import { cmsQueryKeys } from '@/services/cms/cmsQueryKeys';
import { getGlobals } from '@/services/cms/getGlobals';
import { GLOBAL_KEYS } from '@/services/cms/getGlobals/schemas';
import { gtmSocialClick } from '@/utils/events';
import { EllipsisHorizontalIcon } from '@heroicons/react/24/solid';
import { useQuery } from '@tanstack/react-query';

const SocialLinks = () => {
  const { isPending, data, isError } = useQuery({
    queryFn: () => getGlobals('company_information'),
    queryKey: [...cmsQueryKeys.getGlobals, GLOBAL_KEYS.COMPANY_INFORMATON],
    staleTime: Infinity,
  });

  const onClickSocialIcon = ({ text, url }: { text: string; url: string }) => {
    gtmSocialClick({
      clickText: text,
      clickUrl: url,
    });
  };

  if (isPending) {
    return <EllipsisHorizontalIcon className="size-11 animate-spin" />;
  }

  if (isError) {
    return null;
  }
  return (
    <div
      className="w-full mt-4 mb-8 flex flex-row flex-wrap gap-[14px]"
      data-component="CMSSocialLinks"
    >
      {data.social_media.map((socialItem, index) => {
        return (
          <a
            onClick={() =>
              onClickSocialIcon({
                url: socialItem.url,
                text: socialItem.icon?.alt ?? '',
              })
            }
            className="flex items-center"
            key={index}
            href={socialItem.url}
            target="_blank"
          >
            <img
              src={socialItem.icon?.url ?? ''}
              alt={socialItem.icon?.url ?? ''}
              loading="lazy"
            />
            {socialItem.title && (
              <div className="ml-2">
                <span>{socialItem.title}</span>
              </div>
            )}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
